export const SET_SHOW_ALERT = 'SET_SHOW_ALERT';
export const SET_MESSAGE = 'SET_MESSAGE';
export const SET_MESSAGE_TITLE = 'SET_MESSAGE_TITLE';
export const SET_BUTTON_TEXT = 'SET_BUTTON_TEXT';

export const SET_HANDLE_CLICK = 'SET_HANDLE_CLICK';
export const SET_SHOW_BUTTON = 'SET_SHOW_BUTTON';
